(() => {
  const gallery = document.querySelector('.tb-gallery');
  const track = gallery?.querySelector('.tb-gallery-track');
  const slides = [...(gallery?.querySelectorAll('.tb-gallery-slide') || [])];
  const thumbs = [...(gallery?.querySelectorAll('[data-i]') || [])];
  const dots = [...(gallery?.querySelectorAll('.tb-gallery-dots i') || [])];
  let galleryIndex = 0;

  function showImage(index) {
    galleryIndex = Math.max(0, Math.min(index, slides.length - 1));
    track?.scrollTo({ left: galleryIndex * track.clientWidth, behavior: 'instant' });
    thumbs.forEach((thumb, i) => thumb.classList.toggle('on', i === galleryIndex));
    dots.forEach((dot, i) => dot.classList.toggle('on', i === galleryIndex));
    const prev = gallery?.querySelector('.tb-gallery-arrow.prev');
    const next = gallery?.querySelector('.tb-gallery-arrow.next');
    if (prev) prev.disabled = galleryIndex === 0;
    if (next) next.disabled = galleryIndex === slides.length - 1;
  }

  thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showImage(index)));
  gallery?.querySelector('.tb-gallery-arrow.prev')?.addEventListener('click', () => showImage(galleryIndex - 1));
  gallery?.querySelector('.tb-gallery-arrow.next')?.addEventListener('click', () => showImage(galleryIndex + 1));
  addEventListener('resize', () => showImage(galleryIndex));
  showImage(0);

  const reviewTrack = document.querySelector('.tb-review-track');
  const reviewPrev = document.querySelector('.tb-review-prev');
  const reviewNext = document.querySelector('.tb-review-next');
  const updateReviewControls = () => {
    if (!reviewTrack) return;
    if (reviewPrev) reviewPrev.disabled = reviewTrack.scrollLeft < 2;
    if (reviewNext) reviewNext.disabled = reviewTrack.scrollLeft >= reviewTrack.scrollWidth - reviewTrack.clientWidth - 2;
  };
  document.querySelector('.tb-review-prev')?.addEventListener('click', () => {
    const card = reviewTrack?.querySelector('.tb-review-card');
    reviewTrack?.scrollBy({ left: -((card?.getBoundingClientRect().width || 300) + 8), behavior: 'smooth' });
  });
  document.querySelector('.tb-review-next')?.addEventListener('click', () => {
    const card = reviewTrack?.querySelector('.tb-review-card');
    reviewTrack?.scrollBy({ left: (card?.getBoundingClientRect().width || 300) + 8, behavior: 'smooth' });
  });
  reviewTrack?.addEventListener('scroll', updateReviewControls, { passive: true });
  updateReviewControls();

  let reviewDragStart = null;
  let reviewDragged = false;
  reviewTrack?.addEventListener('pointerdown', event => {
    if (event.pointerType !== 'mouse' || event.button !== 0) return;
    reviewDragStart = { x: event.clientX, left: reviewTrack.scrollLeft, id: event.pointerId };
    reviewDragged = false;
  });
  reviewTrack?.addEventListener('dragstart', event => event.preventDefault());
  reviewTrack?.addEventListener('pointermove', event => {
    if (!reviewDragStart || event.pointerId !== reviewDragStart.id) return;
    const distance = event.clientX - reviewDragStart.x;
    if (!reviewDragged && Math.abs(distance) <= 5) return;
    if (!reviewDragged) {
      reviewDragged = true;
      reviewTrack.setPointerCapture(event.pointerId);
      reviewTrack.classList.add('is-dragging');
    }
    reviewTrack.scrollLeft = reviewDragStart.left - distance;
  });
  const finishReviewDrag = event => {
    if (!reviewDragStart || event.pointerId !== reviewDragStart.id) return;
    reviewDragStart = null;
    if (reviewTrack.hasPointerCapture(event.pointerId)) reviewTrack.releasePointerCapture(event.pointerId);
    if (!reviewTrack.classList.contains('is-dragging')) return;
    reviewTrack.classList.remove('is-dragging');
    const card = reviewTrack.querySelector('.tb-review-card');
    const step = (card?.getBoundingClientRect().width || 300) + 8;
    reviewTrack.scrollTo({ left: Math.round(reviewTrack.scrollLeft / step) * step, behavior: 'smooth' });
  };
  reviewTrack?.addEventListener('pointerup', finishReviewDrag);
  reviewTrack?.addEventListener('pointercancel', finishReviewDrag);

  const closeReview = lightbox => {
    lightbox.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(() => lightbox.remove(), 250);
  };

  document.querySelectorAll('.tb-zoom-review img, .tb-review-card > img').forEach(image => {
    image.addEventListener('click', () => {
      if (reviewDragged && image.closest('.tb-review-card')) {
        reviewDragged = false;
        return;
      }
      const lightbox = document.createElement('div');
      lightbox.className = 'tb-review-lightbox';
      lightbox.setAttribute('role', 'dialog');
      lightbox.setAttribute('aria-modal', 'true');
      lightbox.setAttribute('aria-label', 'Expanded customer testimonial');
      lightbox.innerHTML = `<button type="button" aria-label="Close testimonial">×</button><img src="${image.currentSrc || image.src}" alt="${image.alt}">`;
      lightbox.addEventListener('click', event => {
        if (event.target === lightbox || event.target.tagName === 'BUTTON') closeReview(lightbox);
      });
      document.body.append(lightbox);
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(() => lightbox.classList.add('is-open'));
      lightbox.querySelector('button').focus();
    });
  });

  addEventListener('keydown', event => {
    const lightbox = document.querySelector('.tb-review-lightbox');
    if (event.key === 'Escape' && lightbox) closeReview(lightbox);
  });

  function updateBundle(input) {
    const price = input.dataset.price;
    const href = `https://shop.sorayalive.com/cart/${input.dataset.variant}:1`;
    document.querySelector('#tb-price').textContent = `$${price}`;
    document.querySelectorAll('.tb-buy').forEach(link => {
      link.href = href;
      link.textContent = `Get my True Baddie necklace · $${price}`;
    });
  }

  document.querySelectorAll('input[name="tb-bundle"]').forEach(input => {
    input.addEventListener('change', () => updateBundle(input));
    if (input.checked) updateBundle(input);
  });
})();
